import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ComponetWithHeader from '../CompentWithHeader/ComponetWithHeader';
import ComponentWithoutHeader from '../ComponentWithoutHeader/ComponentWithoutHeader';
import ComponentWithoutSideNav from '../ComponentWithoutSideNav/ComponentWithoutSideNav';
import AuthService from '../../services/AuthService';

/**
 * public route component - redirects to home if already authenticated
 */
const PublicRoute = ({ component: Component, sidenav, header }) => {
  const isAuthenticated = AuthService.isAuthenticated();

  if (isAuthenticated === true) {
    return <Navigate to="/" replace />;
  }

  if (header === true && sidenav === true) {
    return <ComponetWithHeader component={Component} />;
  } else if (header === true && sidenav === false) {
    return <ComponentWithoutSideNav component={Component} />;
  } else {
    return <ComponentWithoutHeader component={Component} />;
  }
};

PublicRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

export default PublicRoute;
